<div class="modal-body threeModal">
  <button type="button" class="close" (click)="closeModal('dismiss')" *ngIf="fromParent">
    <span aria-hidden="true">&times;</span>
  </button>
  <div class="container-fluid product-wrapper">
    <div class="row default-according style-1 faq-accordion">
      <div
        [ngClass]="fromParent ? 'col-xl-12 col-lg-12 col-md-12 p-0' : 'col-xl-8 xl-60 col-lg-6 col-md-7 offset-xl-2 p-0'">
        <div class="card border">
          <div class="card-body">
            <div class="sample-Box">
              <h4>How {{pageName}} Work</h4>
              <div class="flex w-full">
                <div
                  style="position:relative;height:0;width:100%;overflow:hidden;box-sizing:border-box;padding-bottom:calc(51.95924764890282% - 0px)">
                  <iframe [src]=pagFaqUrl width="100%" height="100%" style="position:absolute;inset:0" allowfullscreen
                    frameborder="0"></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>